import { Box } from '@mui/material'
import { GridColDef } from '@mui/x-data-grid-premium'
import { useMemo } from 'react'
import { TemplateParametersTableProps } from './Tables.types'
import { BaseTable } from 'Features/Table/BaseTable.view'
import { format } from 'date-fns'
import { ExtendedGridColDef } from 'Features/Table/BulkUpdateModal'

export const TemplateParameterTable = ({
  data,
  isLoading,
  updateTableData,
  updateParametersData,
  isUploading,
}: TemplateParametersTableProps) => {
  const columns: ExtendedGridColDef[] = useMemo(
    () => [
      {
        headerName: 'Base source site code',
        field: 'baseSourceSiteCode',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'Work centre code',
        field: 'workCentreCode',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'SKU code',
        field: 'skuCode',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'Cycle time',
        field: 'cycleTime',
        flex: 1,
        type: 'number',
      },
      {
        headerName: 'Formatted date',
        field: 'formattedDate',
        flex: 1,
        type: 'string',
        valueFormatter: (params) => {
          if (!params) return ''
          return format(new Date(params), 'yyyy-MM-dd')
        },
      },
      {
        headerName: 'In template',
        field: 'inTemplate',
        flex: 1,
        type: 'boolean',
      },
      {
        headerName: 'Production week',
        field: 'productionWeek',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'Production sequence',
        field: 'productionSequence',
        flex: 1,
        type: 'number',
      },
      {
        headerName: 'Template start date',
        field: 'templateStartDate',
        flex: 1,
        type: 'string',
        valueFormatter: (params) => {
          if (!params) return ''
          return format(new Date(params), 'yyyy-MM-dd')
        },
      },
      {
        headerName: 'Template end date',
        field: 'templateEndDate',
        flex: 1,
        type: 'string',
        valueFormatter: (params) => {
          if (!params) return ''
          return format(new Date(params), 'yyyy-MM-dd')
        },
      },
    ],
    [data]
  )

  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
      }}
    >
      <BaseTable
        data={data ?? []}
        columns={columns}
        isLoading={isLoading}
        updateTableData={updateTableData}
        //uploadData={updateParametersData} // Pass upload function to BaseTable
        //isUploading={isUploading}
        isSaving={false}
        checkBoxSelection={false}
        showTableToolBar={true}
        pinnedColumns={['baseSourceSiteCode', 'workCentreCode', 'skuCode']}
        downloadFileName="TemplateParameters"
      />
    </Box>
  )
}
